import React from 'react';

import SectionContainer from 'components/sectionContainer';

import MarketChartsIntro from './MarketChartsIntro';
import MarketIndex from './MarketIndex';
import { marketCharts } from './scss/MarketCharts.module.scss';

const MarketCharts = () => {
  return (
    <div className={marketCharts}>
      <SectionContainer>
        <MarketChartsIntro />
        <MarketIndex />
      </SectionContainer>
    </div>
  );
};

MarketCharts.propTypes = {};

MarketCharts.defaultProps = {};

export default MarketCharts;
